export const getTranslateClass = (
  direction: "left" | "right" | "top" | "bottom"
): string => {
  switch (direction) {
    case "left":
      return "-translate-x-20";
    case "right":
      return "translate-x-20";
    case "top":
      return "-translate-y-20";
    case "bottom":
      return "translate-y-20";
    default:
      return "";
  }
};
